export default () => ({
  customerInvoices: [],
  availablePlans: [],
  loading: false,
});
